module.exports = __webpack_public_path__ + "fonts/Roboto-300-greek-ext24.eb17caf.woff2";